import { createAsyncThunk } from '@reduxjs/toolkit';

import { adminAuthApi } from 'src/api';

import { setAdminData } from './adminAuth.slice';

import { ROUTE } from 'src/constants';

export const loginAdminUser = createAsyncThunk('auth/login-admin-user', async (data) => {
  try {
    const { payload, navigate } = data;

    const response = await adminAuthApi.loginAdminUser(payload);

    localStorage.setItem('admin-session', true);

    navigate(ROUTE.ADMIN.ORDERS.MAIN);

    return response;
  } catch (error) {
    console.error(error);
    localStorage.removeItem('admin-session');
  }
});

export const logoutAdminUser = createAsyncThunk('auth/logout-admin-user', async (data) => {
  try {
    const { navigate } = data;

    const response = await adminAuthApi.logoutAdminUser();

    localStorage.removeItem('admin-session');

    navigate(ROUTE.ADMIN.LOGIN.MAIN);

    return response;
  } catch (error) {
    console.error(error);
  }
});

export const getAdminSession = createAsyncThunk(
  'auth/get-admin-session',
  async (data, thunkApi) => {
    try {
      const response = await adminAuthApi.getAdminSession();

      localStorage.setItem('admin-session', response?.success);

      if (data?.navigate) {
        if (!response?.success) {
          localStorage.removeItem('admin-session');
          data?.navigate(ROUTE.ADMIN.LOGIN.MAIN);
        }
      }

      thunkApi.dispatch(setAdminData(response));

      return response?.success;
    } catch (error) {
      console.error(error);
    }
  },
);
